// Path: src/components/chat/MessageList.tsx
// Removed prompts, added online users display next to Community.
// Improved UI layout to match screenshot, enhanced mobile responsiveness.
// 06/07/25 8:07 PM +07
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const MessageListContainer = styled.div`
  min-height: 0;
  overflow-y: auto;
  border-top: 1px solid #e5e7eb;
  padding: 1rem 1rem 0.125rem;
  max-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MessageItem = styled.div<{ type: string }>`
  padding: 0.5rem 0;
  display: flex;
  flex-direction: column;
  width: 80%;
  &:first-child {
    padding-top: 0;
  }
  ${(props) =>
    props.type === 'user'
      ? `
        align-items: flex-end;
        .message {
          background-color: rgba(37, 99, 235, 0.7);
          color: white;
          text-align: right;
        }
        .time {
          text-align: right;
        }
      `
      : `
        align-items: flex-start;
        .message {
          background-color: #e5e7eb;
        }
        .time {
          text-align: left;
        }
      `}
  .time {
    font-size: 0.75rem;
    color: #6b7280;
    padding: 0 0.5rem;
  }
  .message {
    max-width: 12rem;
    padding: 0.25rem 0.5rem;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    word-wrap: break-word;
  }
`;

const TypingIndicator = styled.div`
  font-style: italic;
  color: #6b7280;
  text-align: center;
  padding: 0.5rem;
`;

const MessageList: React.FC<{
  messages: any[];
  onlineUsers: number;
  isExpanded: boolean;
  isAwaitingResponse: boolean;
  chatType: 'olsSupport' | 'community';
}> = ({ messages, onlineUsers, isExpanded, isAwaitingResponse, chatType }) => {
  const messageEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isExpanded && messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isExpanded]);

  return (
    <MessageListContainer>
      {isExpanded && (
        <div style={{ padding: '0.5rem', textAlign: 'center', color: '#16a34a' }}>
          {chatType === 'community' && `Community (${onlineUsers} online)`}
          {chatType === 'olsSupport' && 'OLS Support'}
        </div>
      )}
      <ul style={{ width: '100%', padding: 0, margin: 0 }}>
        {messages.map((msg) => (
          <li key={msg.id} style={{ listStyle: 'none' }}>
            <MessageItem type={msg.type}>
              <div className="time">{new Date(msg.timestamp?.toDate()).toLocaleTimeString()}</div>
              <div className="message">{msg.text}</div>
            </MessageItem>
          </li>
        ))}
        {isAwaitingResponse && <TypingIndicator>Typing...</TypingIndicator>}
      </ul>
      <div ref={messageEndRef} />
    </MessageListContainer>
  );
};

export default React.memo(MessageList);